export const ExtensionOnly = ({ children }) => {
    return EXT_MODE ? children : null
}

export const SDKOnly = ({ children }) => {
    return SDK_MODE ? children : null
}
